// @flow
import React, { useState, useEffect, useRef } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Switch from '@material-ui/core/Switch';


const useStyles = makeStyles({
    root: {
        backgroundColor: (props) => (props.enabled ? props.activeBackgroundColor : props.inactiveBackgroundColor),
        borderRadius: '8px',
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
    },

    activeTrack: {
        backgroundColor: 'green',
        opacity: '1 !important'
    }
});

export type Props = $ReadOnly<{|
    enabled: boolean,
    activeBackgroundColor: string,
    inactiveBackgroundColor: string,

    onChange: (enabled: boolean) => void
|}>;

function EnableButton({ enabled, activeBackgroundColor, inactiveBackgroundColor, onChange }: Props) {
    const classes = useStyles({ enabled, activeBackgroundColor, inactiveBackgroundColor });
    const [checked, setChecked] = useState(enabled);
    const checkedRef = useRef();

    const handleChange = (e) => {
        setChecked(e.target.checked);
        onChange(e.target.checked)
    };

    checkedRef.current = checked;

    useEffect(() => {
        if(enabled !== checkedRef.current) {
            setChecked(enabled);
        }
    }, [enabled]);

    return (
        <div className={classes.root}>
            <Switch
                checked={checked}
                color="default"
                size="small"
                classes={{
                    track: checked && classes.activeTrack
                }}
                onChange={handleChange}
            />
        </div>
    );
}

export default EnableButton;